import React from 'react';
import HelloWorld from './../../../components/HelloWorld/HelloWorld';

/** Custom message */
export default function ExampleHelloWorld() {
  return <HelloWorld message="This is miedzyslowami's component library" />
}



// WEBPACK FOOTER //
// ./src/docs/examples/HelloWorld/ExampleHelloWorld.js